import { ComponentType, LazyExoticComponent, lazy } from "react"

/**
 * Wraps `React.lazy` for modules that use named exports instead of a default
 * export. The loader returns the module record; `name` selects the exported
 * component by key.
 */
export function lazyNamed<T extends ComponentType<any>>(
  loader: () => Promise<Record<string, unknown>>,
  name: string,
): LazyExoticComponent<T> {
  return lazy(async () => {
    const mod = await loader()
    return { default: mod[name] as T }
  })
}
